var $0d112c912368aa01$exports = {};
const $0d112c912368aa01$var$url = "https://pizzaapi-kzs1.onrender.com/message" //URL till mitt API
;
const $0d112c912368aa01$var$contactFormEl = document.getElementById("contactForm");
/* funktion för att läsa in datan i formuläret */ const $0d112c912368aa01$var$contactBtnEl = document.getElementById("submit");
$0d112c912368aa01$var$contactBtnEl.addEventListener("click", (e)=>{
    e.preventDefault();
    let name = document.getElementById("name").value;
    let email = document.getElementById("email").value;
    let message = document.getElementById("message").value;
    $0d112c912368aa01$var$createMessage(name, email, message);
});
/* Funktion för att lägga till meddelanden i databasen */ async function $0d112c912368aa01$var$createMessage(name, email, message) {
    let contact = {
        name: name,
        email: email,
        message: message
    };
    const response = await fetch($0d112c912368aa01$var$url + "/", {
        method: "POST",
        headers: {
            "Content-Type": "Application/json"
        },
        body: JSON.stringify(contact)
    });
    const data = await response.json();
    console.log(data);
    if (data.error) console.log(data.error);
    else {
        let name = document.getElementById("name");
        let email = document.getElementById("email");
        let message = document.getElementById("message");
        name.value = "";
        email.value = "";
        message.value = "";
        $0d112c912368aa01$var$contactBtnEl.value = "Tack f\xf6r meddelandet!";
        setTimeout(()=>{
            $0d112c912368aa01$var$contactBtnEl.value = "SKICKA!";
        }, "3000");
    }
}


//# sourceMappingURL=index.0365c59b.js.map
